import { Module, ActionTree, MutationTree, GetterTree } from "vuex"
import { RootState } from "@/store/RootStore"
import { make } from "vuex-pathify"
import Services from "@/services/Services"
import { Tenant } from "rp-components"

const namespaced: boolean = true

//===================================
// Request payloads
//===================================
export interface LoadTenantRequest {
    propertyId: number
    tenantId: string
    subTenantId?: string
}

//===================================
// State
//===================================
export interface TenantState {
    propertyId?: number
    tenant?: Tenant
    tenants?: Tenant[]
}

const defaultState = () => {
    return <TenantState>{
        propertyId: undefined,
        tenant: undefined,
        tenants: undefined
    }
}

export const state: TenantState = defaultState()

//===================================
// Getters
//===================================
const getters: GetterTree<TenantState, RootState> = {
    ...make.getters(state)
}

//===================================
// Actions
//===================================
export const actions: ActionTree<TenantState, RootState> = {
    ...make.actions(state),

    resetState({ commit }) {
        commit("resetState")
    },

    async loadTenants({ state, dispatch }, propertyId: number) {
        if (state.propertyId != propertyId || state.tenants == undefined) {
            const tenants = await Services.tenant.getTenants(propertyId)
            await dispatch("setTenants", tenants)
        }
    },

    async loadTenant({ dispatch }, request: LoadTenantRequest) {
        if (request.subTenantId) {
            const tenant = await Services.tenant.getSubTenant(request.propertyId, request.tenantId, request.subTenantId)
            dispatch("setTenant", tenant)
        } else {
            const tenant = await Services.tenant.getTenant(request.propertyId, request.tenantId)
            dispatch("setTenant", tenant)
        }
    }
}

//===================================
// Mutators
//===================================
const mutations: MutationTree<TenantState> = {
    ...make.mutations(state),

    resetState(state) {
        const reset = defaultState()
        state.propertyId = reset.propertyId
        state.tenant = reset.tenant
        state.tenants = reset.tenants
    }
}

//===================================
// Module
//===================================
export const tenant: Module<TenantState, RootState> = {
    namespaced,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
}
